import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    uploadPaper: {
      position: 'relative',
      marginInlineStart: '8px',
      background: theme.palette.grey[100],
      border: `1px dotted ${theme.palette.primary.light}`,
      padding: theme.spacing(6),
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      transform: 'scale(1)',
      width: '100%',
      marginInlineEnd: theme.spacing(1),
      overflow: 'hidden',
      transition: 'ease .2s transform,ease .2s border',
      '&:hover': {
        borderColor: theme.palette.grey[700],
      },
      '&:active': {
        transform: 'scale(.98)',
      },
      '& *': {
        outline: 'none',
      },
    },
    dragHereIcon: {
      fontSize: 50,
      color: theme.palette.grey[600],
    },
    dragHereText: {
      paddingTop: theme.spacing(2),
      color: theme.palette.grey[600],
      fontFamily: 'Vazir',
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 40,
      marginBottom: 13,
      marginTop: 13,
      color: theme.palette.grey[600],
    },
    backdrop: {
      opacity: '0.4 !important',
    },
  };
});